import React, {Fragment} from 'react';
import autobind from 'autobind-decorator';
import {Col, Container, FormControl, Row} from 'react-bootstrap';

import {BaseTableFilter} from "../../Common/Tables/BaseTableFilter";
import {service as OrganizationService} from "../../../Services/OrganizationService";

export class UsersTableFilter extends BaseTableFilter {
    constructor(props) {
        super(props);

        this.setInitialState({
            organizations: [],
            organizationId: "",
            textFilter: ""
        });
    }

    @autobind
    loadData() {
        super.loadData();

        OrganizationService.GetOrganizations().then((x) => {
            this.setState({
                organizations: x.result
            });
        });
    }

    @autobind
    generateFilters() {
        let filters = [];

        if(this.state.organizationId != "") {
            filters.push({
                code: 'organizationId',
                isSet: true,
                logic: (x) => x.organizationId == this.state.organizationId
            });
        }

        if(this.state.textFilter != "") {
            filters.push({
                code: 'textFilter',
                isSet: true,
                logic: (x) =>
                    x.name.toUpperCase().includes(this.state.textFilter.toUpperCase()) ||
                    x.email.toUpperCase().includes(this.state.textFilter.toUpperCase())
            });
        }

        this.updateFilters(filters);
    }

    @autobind
    updateOrganizationId(event) {
        this.setState({ organizationId: event.target.value }, () => {
            this.generateFilters();
        });
    }

    @autobind
    updateTextFilter(event) {
        this.setState({ textFilter: event.target.value }, () => {
            this.generateFilters();
        });
    }

    @autobind
    _render() {
        return <Fragment>
            <Col xs={3} key="org" className="d-flex align-items-center">
                 { this.state.organizations.length > 1 ?
                 <FormControl
                     style={{width: '100%'}}
                     as="select"
                     placeholder="Select an Organization"
                     value={this.state.organizationId}
                     onChange={this.updateOrganizationId}
                 >
                     <option value="" key="">Select an Organization</option>
                    {
                        this.state.organizations.map((x) =>
                            <option key={x.organizationId} value={x.organizationId}>{x.name}</option>
                        )
                    }
                 </FormControl>
                 : null }
             </Col>
             <Col xs={3} key="text" className="d-flex align-items-center">
                 <FormControl
                     style={{width: '100%'}}
                     type="text"
                     autoCorrect="off"
                     autoCapitalize="off"
                     autoComplete="off"
                     spellCheck={false}
                     value={this.state.textFilter}
                     placeholder="Search Users"
                     onChange={this.updateTextFilter}
                 />
             </Col>
        </Fragment>;
    }
}
